<label class="radio" [class.is-disabled]="disabled()">
  <input class="radio-container" type="radio" [checked]="isChecked()" [disabled]="disabled()" (change)="toggleChecked()"
    (click)="onClickUnCheck()" [name]="name()">
  <ui-inline-svg class="radio-icon" [name]="iconName()" [style.width]="size() + 'px'"
    [style.height]="size() + 'px'"></ui-inline-svg>
  <span class="radio-text">
    <ng-content></ng-content>
  </span>
</label>